import React from "react";
import { useFormikContext } from "formik";
import FormField from "../VendorOnboarding/FormField";

const Step7 = () => {
  const { values, setFieldValue, touched, errors } = useFormikContext();

  React.useEffect(() => {
    if (!values.can_enter_without_presence && values.can_enter_details) {
      setFieldValue("can_enter_details", "");
    }
  }, [values.can_enter_without_presence, values.can_enter_details, setFieldValue]);

  return (
    <div className="w-full">
      <h3 className="text-[#242424] font-medium mb-2">
        Can a technician enter the property if no one is home?{" "}
      </h3>
      <h4 className="text-[#595959] font-medium mb-4">
        If no one is home and no access instructions are provided, the
        technician won't be able to complete the job and a trip fee may apply.
      </h4>

      <FormField
        label=""
        name="can_enter_without_presence"
        type="radio"
        options={[
          {
            value: true,
            label: "Yes - The technician can enter without someone present",
          },
          {
            value: false,
            label: "No - I prefer to be present during the appointment",
          },
        ]}
      />
      {values.can_enter_without_presence && (
        <div className="mt-4">
          <FormField
            label="Entry instructions"
            name="can_enter_details"
            type="textarea"
            placeholder="Provide gate codes, lockbox info, etc."
            error={errors.can_enter_details}
            touched={touched.can_enter_details}
          />
        </div>
      )}
    </div>
  );
};

export default Step7;
